import { useState } from "react";
import "../styles/contact.css";
import axios from "axios";
import Constant from "../helper/Constant";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    image: null,
  });

  const [loading, setLoading] = useState(false);

  /* HANDLE INPUT CHANGE */

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  /* HANDLE FILE CHANGE */

  const handleFileChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      image: e.target.files[0],
    }));
  };

  /* SUBMIT FORM */

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.name ||
      !formData.email ||
      !formData.phone ||
      !formData.message
    ) {
      alert("Please fill all required fields");
      return;
    }

    try {
      setLoading(true);

      const data = new FormData();

      data.append("name", formData.name);
      data.append("email", formData.email);
      data.append("phone", formData.phone);
      data.append("message", formData.message);

      if (formData.image) {
        data.append("image", formData.image);
      }

      await axios.post(Constant.postUrls.postEnquiry, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      alert("Message sent! Our team will get back to you soon.");

      /* RESET FORM */

      setFormData({
        name: "",
        email: "",
        phone: "",
        message: "",
        image: null,
      });
    } catch (error) {
      alert(error?.response?.data?.message || "Error sending message");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="contact" id="contact">
      <div className="contact-overlay">
        <div className="contact-container">
          {/* TITLE */}

          <div className="contact-title-wrapper">
            <span className="contact-line" />

            <div className="contact-title-text">
              <h2>Contact Us</h2>

              <p>Share your 3D printing, miniature, or custom product requirement.</p>
            </div>

            <span className="contact-line" />
          </div>

          {/* FORM */}

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="contact-row">
              <input
                type="text"
                placeholder="Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
              />

              <input
                type="email"
                placeholder="Email"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />

              <input
                type="text"
                placeholder="Phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>

            <div className="full-width">
              <textarea
                placeholder="Message"
                name="message"
                value={formData.message}
                onChange={handleChange}
              />
            </div>

            <div className="full-width file-upload-wrapper">
              <label className="file-label">Attach Image (optional)</label>

              <input
                type="file"
                accept="image/*"
                className="file-input"
                onChange={handleFileChange}
              />
            </div>

            <button type="submit">
              {loading ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;

// import "../styles/contact.css";
// import axios from "axios";
// import Constant from "../helper/Constant";

// const ContactUs = () => {

//   return (
//     <section className="contact" id="contact">
//       <div className="contact-overlay">
//         <div className="contact-container">

//           {/* TITLE */}
//           <div className="contact-title-wrapper">
//             <span className="contact-line" />
//             <div className="contact-title-text">
//               <h2>Get in Touch</h2>
//               <p>Contact Us Today!</p>
//             </div>
//             <span className="contact-line" />
//           </div>

//           {/* FORM */}
//           <form className="contact-form">

//             {/* ROW */}
//             <div className="contact-row">
//               <input type="text" placeholder="Name" />
//               <input type="email" placeholder="Email" />
//               <input type="text" placeholder="Phone" />
//             </div>

//             {/* MESSAGE */}
//             <div className="full-width">
//               <textarea placeholder="Message"></textarea>
//             </div>

//             {/* ATTACH IMAGE */}
//             <div className="full-width file-upload-wrapper">
//               <label className="file-label">
//                 Attach Image (optional)
//               </label>

//               <input
//                 type="file"
//                 accept="image/*"
//                 className="file-input"
//               />
//             </div>

//             <button type="submit">Send Message</button>

//           </form>

//         </div>
//       </div>
//     </section>
//   );
// };

// export default ContactUs;
